import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '#client/lib/cn';
import { Button } from './Button';

interface PaginationProps {
  page: number;
  limit: number;
  count: number;
  onPageChange: (page: number) => void;
  /** Plural noun for the summary line, e.g. "patients". */
  label?: string | undefined;
  className?: string | undefined;
}

export function Pagination({
  page,
  limit,
  count,
  onPageChange,
  label = 'records',
  className,
}: PaginationProps) {
  const totalPages = Math.max(1, Math.ceil(count / limit));
  const first = count === 0 ? 0 : (page - 1) * limit + 1;
  const last = Math.min(page * limit, count);

  return (
    <nav className={cn('c-pagination', className)} aria-label="Pagination">
      <p className="c-pagination__summary">
        {count === 0 ? `No ${label}` : `${first}–${last} of ${count} ${label}`}
      </p>
      <div className="c-pagination__controls">
        <Button
          size="sm"
          icon={<ChevronLeft />}
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          aria-label="Previous page"
        />
        <span className="c-pagination__page">
          Page {page} of {totalPages}
        </span>
        <Button
          size="sm"
          icon={<ChevronRight />}
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          aria-label="Next page"
        />
      </div>
    </nav>
  );
}
